import { render, staticRenderFns } from "./WebSiteSetting.vue?vue&type=template&id=c64ecec2&scoped=true&"
import script from "./WebSiteSetting.vue?vue&type=script&lang=js&"
export * from "./WebSiteSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ecec2",
  null
  
)

export default component.exports